import { render, staticRenderFns } from "./BasicSelectItem.vue?vue&type=template&id=48892cc0&scoped=true&"
import script from "./BasicSelectItem.vue?vue&type=script&lang=js&"
export * from "./BasicSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./BasicSelectItem.vue?vue&type=style&index=0&id=48892cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48892cc0",
  null
  
)

export default component.exports